/**
 * Tracks the most recent throttle event per data source so that shared UI
 * components (e.g. WithStatusWrapper) can display a helpful message when a
 * card fails shortly after a throttle response.
 */

const throttleTimestamps = new Map<string, number>();

const THROTTLE_WINDOW_MS = 30_000; // 30 seconds

export const markThrottled = (source: string): void => {
    throttleTimestamps.set(source, Date.now());
};

export const wasRecentlyThrottled = (source?: string): boolean => {
    const now = Date.now();
    if (source) {
        const ts = throttleTimestamps.get(source);
        return ts !== undefined && now - ts < THROTTLE_WINDOW_MS;
    }
    for (const ts of throttleTimestamps.values()) {
        if (now - ts < THROTTLE_WINDOW_MS) {
            return true;
        }
    }
    return false;
};

export const getThrottledSource = (): string | undefined => {
    const now = Date.now();
    for (const [source, ts] of throttleTimestamps.entries()) {
        if (now - ts < THROTTLE_WINDOW_MS) {
            return source;
        }
    }
    return undefined;
};
